/** A pilha LÓGICA das superfícies do planner que carregam `role="dialog"`, do
 *  fundo para o topo (lista cheia < mapa cheio < gaveta de detalhes). Lida
 *  pela faixa de busca expandida da lista (o Esc dela só recolhe com ela no
 *  topo) e pela Página do Hotel da bancada; o Esc das telas em diálogo em si é
 *  do Base UI. A ordem do documento NÃO serve de pilha: portais saem para o fim
 *  do `body` fora de ordem. Cada superfície conhecida carrega seu marcador;
 *  diálogo sem marcador é aninhado/desconhecido (galeria, quartos, calendário)
 *  e assume-se no topo. */
const LAYER_MARKERS = [
  'data-hotel-all-results-dialog',
  'data-hotel-map-fullscreen-dialog',
  'data-hotel-details-drawer',
] as const;

function layerRank(dialog: Element): number {
  const index = LAYER_MARKERS.findIndex((marker) => dialog.hasAttribute(marker));
  return index === -1 ? LAYER_MARKERS.length : index;
}

/** Há outro dialog ACIMA deste na pilha lógica? Esc só fecha o do topo.
 *  Empate de degrau (dois aninhados) se resolve pela ordem do documento —
 *  quem montou depois está por cima. `alertdialog` conta: os avisos do host da
 *  bancada (preço mudou, oferta que não confirmou) são decisões modais SEM
 *  marcador, logo no topo — sem contá-los o Escape que declina o aviso
 *  fecharia a lista inteira junto. */
export function hasForegroundDialog(dialog: Element | null): boolean {
  const dialogs = [...document.querySelectorAll('[role="dialog"], [role="alertdialog"]')];
  if (dialog === null) return dialogs.length > 0;
  const rank = layerRank(dialog);
  const index = dialogs.indexOf(dialog);
  return dialogs.some((candidate, candidateIndex) => {
    if (candidate === dialog) return false;
    const candidateRank = layerRank(candidate);
    return candidateRank > rank || (candidateRank === rank && candidateIndex > index);
  });
}
